export default __webpack_public_path__ + "static/AppInterview3-7f693c9f3f9109229ad519d8cb1334cd.png";